/**
 * @internal
 */
export const INTERNAL_COPY_KEY = "application/x-edix-editor";
